import CoreuiController from "../lib/coreui-controller"
import Chip from "../coreui/chip"

export default class CoreuiChipController extends CoreuiController {
  static Component = Chip
}
